import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { Button } from '../../../components/ui/button';
import { FAILURE_LOGO_PATH } from '../../../constants/logo';

interface PinLimitFailurePopupProps {
  errorMessage?: string;
  onClose: () => void;
  onRetry?: () => void;
}

const PinLimitFailurePopup: React.FC<PinLimitFailurePopupProps> = ({
  errorMessage = 'Failed to update the limit. Please try again.',
  onClose,
  onRetry
}) => {
  return (
    <div className="p-2">
      <img src={FAILURE_LOGO_PATH} className="mx-auto h-32" alt="Failed" />
      <h2 className="mb-1 mt-4 text-center text-lg font-bold">Update Failed</h2>
      <p className="mb-4 text-center text-sm text-gray-500">
        Your transaction limit could not be saved.
      </p>

      <div className="rounded-xl border border-gray-100 bg-gray-50 p-4">
        <div className="flex items-start gap-3 pt-3">
          <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
              Reason
            </p>
            <p className="text-sm font-medium text-gray-900">{errorMessage}</p>
          </div>
        </div>
      </div>

      <div className="mt-6 flex gap-3">
        <Button
          type="button"
          className={onRetry ? 'flex-1' : 'w-full'}
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

export default PinLimitFailurePopup;
